import {Box, styled} from "@mui/material";
import React from "react";

interface RoadmapReportElInterface {
    title: string;
    description: string;
}

const RoadmapReportsItem = styled(Box)({
    position: "relative",
    fontSize: "1.2rem",
    fontWeight: 400,
    color: "#ffc371",
    zIndex: 2,
    textAlign: "center",
    textShadow: "1px 1px 2px black, 0 0 15px #ff5f6d, 0 0 5px #ff5f6d",
    borderBottom: "1px solid #ff5f6d",
    "& p":{
        fontSize: "1.1rem",
        fontWeight: 600,
    },
    "&:before":{
        content: "' '",
        position: "absolute",
        height: "20px",
        width: "1px",
        background: "#ff5f6d",
        left: 0,
        bottom: 0,
    },
    "&:after":{
        content: "' '",
        position: "absolute",
        height: "20px",
        width: "1px",
        background: "#ff5f6d",
        right: 0,
        bottom: 0,
    },
    "@media(max-width: 768px)":{
        fontSize: "1rem",
        "& p":{
            fontSize: "0.8rem",
        },
    }
});

const RoadmapReportEl = ({title, description}: RoadmapReportElInterface): JSX.Element => {
    return (
        <RoadmapReportsItem>
            {title}
            <p>
                {description}
            </p>
        </RoadmapReportsItem>
    );
};

export default RoadmapReportEl;
